
export interface MxTableOperationItems {
  icon: string;
  label: string;
  type?: MxMenuType;
  styleClass?: string;
  disabled?: (event?: any) => boolean;
  loading?: boolean;
  command: (event?: any, rawData?: any) => void;
}

export enum MxMenuType{
  SpeedDial= 0,
  Tiered = 10
}
